import { render, staticRenderFns } from "./OfficialTopic.vue?vue&type=template&id=f45474be&scoped=true"
import script from "./OfficialTopic.vue?vue&type=script&lang=js"
export * from "./OfficialTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45474be",
  null
  
)

export default component.exports